import { BeeswaxReportProperties as ReportProperties } from '@/Enums/Report/BeeswaxReportProperties.enum';
import TotalMetric from '@/Enums/ReportingDashboard/TotalMetric.enum';
import { selectFootTraffic, selectFootTrafficTotals } from '@/store/selectors/attribution/footTraffic.selectors';
import { createSelector } from '@reduxjs/toolkit';
import {
  type IExecutiveSummaryInput,
  getDwellInsight,
  getExecutiveSummary,
  getLoyaltyInsight,
  getPeakDayInsight,
  getPeakHourInsight,
  getTradeAreaInsight,
} from './templates';

export const selectFootTrafficExecutiveSummary = createSelector(
  [selectFootTraffic, selectFootTrafficTotals],
  (
    { footTrafficImpressionsReportsRequestId, footTrafficVisitsReportsRequestId, totals, freqReport },
    { totals: derivedTotals },
  ) => {
    const loading = !!footTrafficImpressionsReportsRequestId || !!footTrafficVisitsReportsRequestId;
    const input: IExecutiveSummaryInput = {
      totalVisits: derivedTotals[TotalMetric.FootTrafficVisits],
      yoyPercentChange: derivedTotals[TotalMetric.YoyPercentChange],
      liftPercent: totals[ReportProperties.LIFT_PERCENT],
      avgWeeklyUniqueVisitors: derivedTotals[TotalMetric.AvgWeeklyUniqueVisitors],
      repeatVisitorPercent: freqReport?.repeatVisitorPercent ?? 0,
    };
    return { loading, text: getExecutiveSummary(input) };
  },
);

export const selectFootTrafficDwellInsight = createSelector(
  [selectFootTraffic],
  ({ footTrafficVisitsReportsRequestId, dwellReport }) => ({
    loading: !!footTrafficVisitsReportsRequestId,
    text: getDwellInsight(dwellReport),
  }),
);

export const selectFootTrafficLoyaltyInsight = createSelector(
  [selectFootTraffic],
  ({ footTrafficVisitsReportsRequestId, freqReport }) => ({
    loading: !!footTrafficVisitsReportsRequestId,
    text: getLoyaltyInsight(freqReport),
  }),
);

export const selectFootTrafficPeakDayInsight = createSelector(
  [selectFootTraffic],
  ({ footTrafficVisitsReportsRequestId, weekdayReport }) => ({
    loading: !!footTrafficVisitsReportsRequestId,
    text: getPeakDayInsight(weekdayReport),
  }),
);

export const selectFootTrafficPeakHourInsight = createSelector(
  [selectFootTraffic],
  ({ footTrafficVisitsReportsRequestId, hourReport }) => ({
    loading: !!footTrafficVisitsReportsRequestId,
    text: getPeakHourInsight(hourReport),
  }),
);

export const selectFootTrafficTradeAreaInsight = (side: 'home' | 'work') =>
  createSelector([selectFootTraffic], ({ footTrafficVisitsReportsRequestId, tradeAreaReport }) => ({
    loading: !!footTrafficVisitsReportsRequestId,
    text: getTradeAreaInsight(tradeAreaReport?.[side], side),
  }));
